/*机构打通相关
i:get || post
h:requestGet ||requestPost
*/
import axios from '../axios'
export default {
    partnersList: () => axios.get('/api/api/mechanism/link/list'),//合作伙伴列表
    openCommunication: (data) => axios.post('/api/api/mechanism/link/store',data),//机构互通开通
}